module.exports = __webpack_public_path__ + "img/hot-tub.2.7cb9907.jpg";